var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"license_box"},[_c('table',{staticClass:"table table-bordered"},[_c('tbody',[_vm._l((_vm.items),function(item,index){return [_c('tr',[_c('td',[_c('label',[_vm._v(_vm._s(item.itemKey))])])]),_c('tr',[_c('td',[_vm._v(_vm._s(item.itemValue))])])]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }